const columnMap = {
    LONG_NAME: { default: 'name' },
    SECURITYNAME: { default: 'name' },

    LAST: { default: 'last' },
    LASTNZ: { default: 'last' },
    LASTNZ_DIV: { default: 'last' },

    TIME: { default: 'time' },

    CHANGE: { default: 'change' },
    CHANGE_7DAYS: { default: 'change' },
    CHANGE_MONTH: { default: 'change' },
    CHANGE_3MONTHS: { default: 'change' },
    CHANGE_YEAR: { default: 'change' },
    CHANGE_1YEAR: { default: 'change' },
    CHANGE_3YEARS: { default: 'change' },
    CHANGE_5YEARS: { default: 'change' },

    CHANGE_PCT: { default: 'percentChange' },
    CHANGE_7DAYS_PCT: { default: 'percentChange' },
    CHANGE_MONTH_PCT: { default: 'percentChange' },
    CHANGE_3MONTHS_PCT: { default: 'percentChange' },
    CHANGE_YEAR_PCT: { default: 'percentChange' },
    CHANGE_1YEAR_PCT: { default: 'percentChange' },
    CHANGE_3YEARS_PCT: { default: 'percentChange' },
    CHANGE_5YEARS_PCT: { default: 'percentChange' },

    MEMBER_NAME: { default: 'member' },
    TRADES_TURNOVER: { default: 'turnover' },
    BROKER_CHANGE: { default: 'percentChange' },
    // @TODO: Add all iterations of ..._INVESTOR_<number> ?
    TOP_INVESTOR: { default: 'investor' }, // Actually .._INVESTOR_<number>
    TOP_POSITION_SHARES: { default: 'stocks' }, // Actually .._SHARES_<number>
    TOP_POSITION_SHARES_PCT: { default: 'share' }, // Custom

    FUNDMGRNAME: { default: 'fundManager' },
    PRICE: { default: 'price' },
    PRICECHANGEPCT: { default: 'percentChange' },
    RET1WEEK: { default: 'returnPercentage' },
    RET1M: { default: 'returnPercentage' },
    RET6M: { default: 'returnPercentage' },
    RETGAVG1YR: { default: 'returnPercentage' },
    RETGAVG3YR: { default: 'returnPercentage' },
    RETGAVG5YR: { default: 'returnPercentage' },
    RETGAVG10YR: { default: 'returnPercentage' },
};

export function getColumnName(column) {
    if (columnMap[column]) {
        return columnMap[column].default;
    }

    return '';
}



/** WEBPACK FOOTER **
 ** /src/shared/service/column.js
 **/